import React, { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import UserLocator from "../data/UserLocator";
import variables from "@/common/globalVariables.js";
import appText from "@/lang/appText";
import PageSection from "@/common/Layout/PageSection";
import Container from "@/common/Layout/Container";
import Title from "@/common/UI/Title";
import DynamicImageBg from "@/common/UI/DynamicImageBg";
import SearchArea from "@/components/jobs/Search/SearchArea";
import { basePath } from "@/root/config";
import JobsCards from "@/components/jobs/JobList/JobsListQuery";
import PopularTerms from "@/components/jobs/PopularTerms/PopularTerms";
import { getJobsFromAPI, getTermsFromAPI } from "@/lib/backend";
import Translator, { ListOfLanguages } from "@/components/hoc/Translator";
import { MdOutlineLanguage } from "react-icons/md";

const landingLogo = "/images/LandingLogo.svg";

// const homePageStyle = `background: linear-gradient(0deg, white 40%, ${variables.mutedColor1} 40%);`;

const homePage = (props) => {
  // return <p>Hello</p>;
  const [userLocation, setUserLocation] = useState({
    name: "Loading...",
    lat: 0,
    lon: 0,
  });

  const userLocator = new UserLocator();

  useEffect(() => {
    userLocator.getLocation().then((res) => {
      setUserLocation(res);
    });
  }, []);

  return (
    <PageSection className="HomePage" column nopadding data-test="indexPage">
      <SEO
        description={`${appText.seo.pages.landing.description}. ${appText.seo.description}! Discover remote jobs, temp work, full-time careers, and high-paying gigs near you. Search faster on one of the best job boards for 2025.`}
        title={`${appText.seo.title}! Remote Gigs, Executive Careers & Jobs Hiring Near You`}
      />
      <DynamicImageBg
        staticImage
        query={
          userLocation.name !== "Loading..."
            ? userLocation.country || userLocation.name
            : "Los Angeles, CA"
        }
      >
        <div className="frame-box">
          <Container>
            {/* <div className="Logos">
              <img src={landingLogo} className="CompanyLogo" />
            </div> */}
            <section className="hero">
              <h1>
                From Gigs to Executive Roles
                <br />
                Find Flexible Work Across Every Industry
              </h1>

              <p className="hero-description">
                Discover temporary jobs, gig work, full-time careers, and
                executive roles across industries – from IT,
                <br />
                healthcare, accounting, sales, warehouse & more.
              </p>

              {/* include this in seo but don't show in UI */}
              <div className="hashtag-line">
                #JobSearch • #NowHiring • #JobsHiring • #RemoteJobs •
                #FlexibleWork • #GigJobs • #TempJobs • #HiringAlert •
                #WorkFromHome • #JobBoard • #CareerGoals • #JobHunt •
                #FullTimeJobs • #PartTimeJobs • #ExecutiveJobSearch •
                #StaffingSolutions • #JobSeeker • #HighPayingJobs •
                #EntryLevelJobs • #BestJobBoards2025 • #JobSearchWebsites •
                #JobBoardsForRemoteWork TorranceJobs AlbanyJobs ValenciaJobs
                OnlineJobs JobSearch NowHiring RemoteJobs JobsNearMe Flexible
                Work FullTimeJobs GigJobs TempJobs PartTimeJobs Jobs
                ExecutiveJobSearch Job Openings Job Hunt CareerGoals
                MarketingJobs ITJobs MaderaJobs BakersfieldJobs FresnoJobs
                JobsNewarkDE ExactStaffJobs WarehouseJobs ForkliftJobs
                ShafterJobs CamarilloJobs ArvinJobs CalabasasJobs LosAngelesJobs
                SacramentoJobs OxnardJobs StaffingJobs SalesJobs AccountingJobs
                HealthcareJobs
              </div>

              <SearchArea location={userLocation.name} />
            </section>
          </Container>
        </div>
      </DynamicImageBg>
      <Container>
        {/* langualge toggler */}
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          title="Change language"
        >
          <MdOutlineLanguage
            size={30}
            color="green"
            style={{
              marginRight: "5px",
            }}
          />
          <ListOfLanguages />
        </div> */}
        <Title size={"l"} center margin capitalize>
          <Translator>{appText.messages.whatsTrending} 😎</Translator>
        </Title>
        <PopularTerms terms={props.terms} />
        <Title size={"l"} center margin capitalize>
          <Translator>{appText.messages.job.latest}</Translator>
        </Title>
        <JobsCards jobs={props.jobs} />
      </Container>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
              "@context": "https://schema.org",
              "@type": "WebSite",
              "url": "${basePath}/",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "${basePath}/jobs?q={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }`,
        }}
      />
      <style jsx>{`
        .frame-box {
          width: 100%;
          aspect-ratio: 3 / 1; /* Maintain shape ratio */
          margin: 0 auto 3rem;
          padding: 4% 6%; /* padding from edge of image so content stays inside frame */
          background-image: url("/images/2400_800_BorderMyExactJobs_SEO.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          text-align: center;
          position: relative;
        }

        .Logos {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          max-width: 500px;
          padding: 20px 30px;
          margin: auto;
        }

        .Logos img {
          width: 100%;
        }

        .CompanyLogo {
          margin-bottom: 15px;
        }

        .PeopleLogo {
          width: 100%;
          max-width: 460px;
        }

        .PeopleLogo img {
          width: 100%;
        }

        @media (max-width: ${variables.mediumScreen}) {
          .Logos,
          .PeopleLogo,
          .CompanyLogo {
             {
              /* display: none; */
            }
          }
        }
        @media (max-width: 1250px) {
          .frame-box {
             {
              /* padding: 50px 0px; */
            }
            aspect-ratio: 3 / 1; /* Maintain shape ratio */
            margin: 0 auto 3rem;
            background-image: url("/images/2400_800_BorderMyExactJobs_SEO.png");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        .hero {
          text-align: center;
           {
            /* padding: 80px 20px 30px; */
          }
        }
        .hero h1 {
          font-size: 2.2em;

          font-weight: bold;

          margin: 0;

          line-height: 1.3;

          color: #222;
        }
        .hero p {
          font-size: 1.5em;

          color: #555;

          margin: 15px auto;

          max-width: 700px;
        }

        @media (max-width: 700px) {
          .Logos {
            display: none;
          }
          .frame-box {
            background-image: url("/images/Mobile1080x1350_BorderMyExactJobs_SEO.png");
            background-size: contain;
            aspect-ratio: 4 / 5; /* Adjust to wrap around content */
             {
              /* padding: 20px 40px; */
            }
          }
          .hero h1 {
            font-size: 1.1em;
          }
          .hero p {
            font-size: 0.8em;
          }
        }

        .hashtag-line {
          font-size: 0.8em;
          color: #555;
          margin: 25px auto 35px;
          max-width: 700px;
          display: none; /* hide this in UI but keep it in SEO */
        }
      `}</style>
    </PageSection>
  );
};

export async function getStaticProps() {
  const jobs = await getJobsFromAPI();
  const terms = await getTermsFromAPI();

  return { props: { jobs, terms }, revalidate: 1 };
}

export default homePage;
